/*eslint-disable*/
import styled from 'styled-components';

export const SingleNewHireException = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SingleNewHireExceptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: -0.5%;
`;

export const SingleNewHireExceptionTitle = styled.div`
  display: flex;
  width: 100%;
`;

export const SingleNewHireExceptionMocked = styled.input`
  height: 30px;
  max-width: 135px;
  margin-top: -15%;
  border: 0px white solid;
  border-radius: 5px;
  width: 100%;
  background-color: #f3f4f8;
  color: #1b1d35;
  font-size: 13pt;
  padding: 5px;
`;
